import {
  Component,
  Input,
  CUSTOM_ELEMENTS_SCHEMA,
  Output,
  EventEmitter,
} from '@angular/core';
import type { LeafAccordionItem } from '@cigna/leaf-web/lib/wc';
import '@cigna/leaf-web/lib/wc/components/accordion-item/accordion-item';

@Component({
  selector: 'cigna-leaf-accordion-item',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-accordion-item
      [heading]="heading"
      [iconBefore]="iconBefore"
      [tertiaryIcon]="tertiaryIcon"
      [brandHeader]="brandHeader"
      [size]="size"
      [headingTagVariant]="headingTagVariant"
      [isActive]="isActive"
      [accordionItemId]="accordionItemId"
      (leaf-active-state-toggle)="handleAccordionClick($event.detail.value)"
      ><ng-content></ng-content
    ></leaf-accordion-item>
  `,
})
export class CignaLeafAccordionItemComponent {
  @Input() heading: LeafAccordionItem['heading'];
  @Input() iconBefore: LeafAccordionItem['iconBefore'] = false;
  @Input() tertiaryIcon: LeafAccordionItem['tertiaryIcon'] = false;
  @Input() brandHeader: LeafAccordionItem['brandHeader'] = false;
  @Input() size: LeafAccordionItem['size'] = 'sm';
  @Input() headingTagVariant: LeafAccordionItem['headingTagVariant'];
  @Input() isActive: LeafAccordionItem['isActive'];
  @Input() accordionItemId: LeafAccordionItem['accordionItemId'];
  @Output() accordionClick = new EventEmitter<boolean>();

  handleAccordionClick(value: boolean): void {
    this.accordionClick.emit(value);
  }
}
